// eslint-disable-next-line import/no-internal-modules
import DateCell from '@insided/deprecated-control/overview/cells/DateCell'

import { SegmentData } from './types'
import { OverviewUsernameCell, OverviewTitleCell } from './Cells'
import percentageFormat from '@insided/control/utils/percentageFormat'

export interface BaseColumn {
  header: string
  size: string
  isFixed?: boolean
}

export interface AccessorColumn extends BaseColumn{
  accessor: string
}

export interface CustomCellColumn<T> extends BaseColumn{
  cell: (props: T) => JSX.Element | string | null
}

export type Column<T = any> = AccessorColumn | CustomCellColumn<T>

export const segmentsOverviewColumns: Array<Column<SegmentData>> = [
  {
    header: 'Title',
    cell: OverviewTitleCell,
    size: 'm-flexible',
    isFixed: true
  },
  {
    header: 'Description',
    cell: ({ segment: { description } }: SegmentData) => description,
    size: 'm-flexible'
  },
  {
    header: 'Creator',
    cell: OverviewUsernameCell,
    size: 'm-flexible'
  },
  {
    header: 'Last edited',
    accessor: 'updated_at',
    cell: ({ segment }: SegmentData) => DateCell('updated_at')(segment),
    size: 'm-flexible'
  },
  {
    header: '% Users',
    cell: ({ user_percentage: userPercentage }: SegmentData) => percentageFormat(userPercentage),
    size: 'xs-right'
  },
  {
    header: '# Users',
    accessor: 'user_count',
    size: 'xs-right'
  }
]
